import React, { useEffect, useState } from 'react';
import { saveCall } from './api';
import './customer-call-notification.css';

const navigate = url => window.location.assign(url);
const dismissed = new Set();
function isDismissed(id) {
  try { return dismissed.has(id) || sessionStorage.getItem(`video-support-dismissed:${id}`) === '1'; }
  catch (_) { return dismissed.has(id); }
}
export default function CustomerCallNotification({ api, pathname, hasSession, onNavigate = navigate }) {
  const [call, setCall] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    let timer;
    setCall(null);
    if (pathname.replace(/\/$/, '') === '/video-support') return undefined;
    const poll = async () => {
      try {
        const calls = hasSession() ? await api('/customer/requests') : [];
        if (!cancelled) setCall(calls.find(item => !isDismissed(item.id)) || null);
      } catch (_) {
        if (!cancelled) setCall(null);
      } finally {
        if (!cancelled) timer = setTimeout(poll, 5000);
      }
    };
    poll();
    return () => { cancelled = true; clearTimeout(timer); };
  }, [api, pathname, hasSession]);
  if (!call) return null;
  const join = async () => {
    setBusy(true);
    setError('');
    try {
      const result = await api(`/${call.id}/customer-resume`, {});
      saveCall(result);
      onNavigate(`/video-support?call=${encodeURIComponent(result.id)}`);
    } catch (err) { setError(err.message || 'Unable to join. Please try again.'); }
    finally { setBusy(false); }
  };
  const later = () => {
    dismissed.add(call.id);
    try { sessionStorage.setItem(`video-support-dismissed:${call.id}`, '1'); } catch (_) { /* Storage may be unavailable. */ }
    setCall(null);
    setError('');
  };
  return <aside className="vs-ready-popup" role="dialog" aria-labelledby="vs-ready-title" aria-describedby="vs-ready-description">
    <div className="vs-ready-icon" aria-hidden="true">✓</div>
    <div aria-live="polite"><p className="vs-ready-eyebrow">VIDEO SUPPORT</p><h2 id="vs-ready-title">Your call is ready</h2>
      <p id="vs-ready-description">Our team accepted your request. Join the call when you’re ready.</p></div>
    {error && <p className="vs-ready-error" role="alert">{error}</p>}
    <div className="vs-ready-actions"><button type="button" onClick={join} disabled={busy}>{busy ? 'Opening call…' : 'Join now'}</button><button type="button" onClick={later} disabled={busy}>Later</button></div>
  </aside>;
}
